import { useState } from 'react';
import AuthService from '../services/AuthService';

const useResetPasswordViewModel = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const resetPassword = async (resetToken, password) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    try {
      await AuthService.resetPassword(resetToken, password);
      setSuccess(true);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    error,
    success,
    resetPassword,
  };
};

export default useResetPasswordViewModel;